module.exports = __webpack_public_path__ + "img/bootcamp.5325987b.svg";